var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ErrorType } from "../types/ErrorType";
/** Same rule as the Publishers module: IČO is exactly 8 digits. */
export var COMPANY_NUMBER_PATTERN = /^\d{8}$/;
export var formatOrganizationName = function (organization) {
    if (organization.source === "LEGAL_DEPOSITS") {
        return "".concat(organization.name, " (PV)");
    }
    return organization.name;
};
/**
 * Organizations synced from an external source (Publishers, Legal deposits) get their
 * company number from that source, so it must not be edited manually.
 */
export var isSyncedOrganization = function (organization) { return !!(organization === null || organization === void 0 ? void 0 : organization.source); };
export var parseOrganizationFilters = function (search) {
    var params = new URLSearchParams(search);
    return {
        name: params.get("name") || "",
        companyNumber: params.get("companyNumber") || "",
        archived: params.get("archived") === "true",
    };
};
export var buildOrganizationSearchParams = function (filters) {
    var params = new URLSearchParams();
    if (filters.name)
        params.set("name", filters.name);
    if (filters.companyNumber)
        params.set("companyNumber", filters.companyNumber);
    params.set("archived", filters.archived.toString());
    return params;
};
/**
 * Reads the type of the first error from a failed backend response. Reads a clone so the
 * body stays available to other handlers; a missing or non-JSON body yields undefined.
 */
export var readErrorType = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var source, body, _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 2, , 3]);
                source = typeof (response === null || response === void 0 ? void 0 : response.clone) === "function" ? response.clone() : response;
                return [4 /*yield*/, (source === null || source === void 0 ? void 0 : source.json())];
            case 1:
                body = (_d.sent());
                return [2 /*return*/, (_c = (_b = body === null || body === void 0 ? void 0 : body.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.type];
            case 2:
                _a = _d.sent();
                return [2 /*return*/, undefined];
            case 3: return [2 /*return*/];
        }
    });
}); };
/** Maps a backend validation error type to the form field it belongs to. */
export var resolveOrganizationSaveError = function (type) {
    switch (type === undefined ? undefined : String(type)) {
        case ErrorType.VALIDATION_ORGANIZATION_COMPANY_NUMBER_ALREADY_EXISTS:
            return {
                field: "companyNumber",
                messageId: "ui-br-users.organization.validation.companyNumber.duplicate",
            };
        case ErrorType.VALIDATION_COMPANY_NUMBER_INVALID:
            return {
                field: "companyNumber",
                messageId: "ui-br-users.organization.validation.companyNumber",
            };
        case ErrorType.VALIDATION_ERROR:
            return {
                field: "name",
                messageId: "ui-br-users.organizationCreate.error.organization.exists",
            };
        default:
            return null;
    }
};
